export enum BasketNotificationStyle {
  default = 'default',
  insidePane = 'inside-pane',
}
